import cloneDeep from 'lodash/cloneDeep'
import { ADD_TO_ROSTER, INIT_ROSTER } from '../../actions/game/roster.actions'
import HEROES from '../../../constants/HEROES'

const initialState = {}
const initialRoster = [
    HEROES.XY001,
]

const getUnitsWithIDs = baseUnits => (
    baseUnits.map(unit => ({
        [unit.ID]: unit,
    }))
)

const rosterReducer = (state = initialState, action) => {
    const { payload } = action

    switch (action.type) {
        case INIT_ROSTER: {
            const roster = getUnitsWithIDs(initialRoster)
            return Object.assign({}, ...roster)
        }
        case ADD_TO_ROSTER: {
            const { baseUnits } = payload
            const newUnits = getUnitsWithIDs(baseUnits)
            return Object.assign(cloneDeep(state), ...newUnits)
        }

        default: {
            return state
        }
    }
}

export default rosterReducer
